import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/measurement-unit-kinds/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const measurementUnitKinds = {
  getAll: apiPathFunc(pathBase),
};
